import { render } from "./StAlert.vue?vue&type=template&id=fc406604"
import script from "./StAlert.vue?vue&type=script&lang=js"
export * from "./StAlert.vue?vue&type=script&lang=js"

import "./StAlert.vue?vue&type=style&index=0&id=fc406604&lang=scss"

import exportComponent from "/Users/ondaa/workspace/schoolmom_qna_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__